import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.valuesList.length != 0)?_c(VSheet,{staticClass:"container-column",staticStyle:{"height":"100%"}},[_c(VDataTable,{staticClass:"container-column",attrs:{"headers":_vm.headersList,"items":_vm.valuesList,"items-per-page":this.valuesList.length,"item-key":"cd","hide-default-footer":"","disable-sort":"","fixed-header":"","height":"100%"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }